@if (this.to.label) {
  <div class="fs-6 mb-2">
    {{ this.to.label | translate }}
    @if (this.to.description) {
      <div>
        <mat-hint class="subline">{{ this.to.description | translate }}</mat-hint>
      </div>
    }
  </div>
}
<mat-card appearance="outlined" class="grid-container">
  <ngx-file-drop [multiple]="false" dropZoneClassName="asset-dropzone" contentClassName="asset-content" (onFileDrop)="dropped($event)">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <ag-grid-angular class="ag-theme-material grid" [gridOptions]="gridOptions"></ag-grid-angular>
      @if (!isReadOnly) {
        <button
          matTooltipPosition="before"
          [matTooltip]="'SHARED.DOCUMENT_ATTACHMENTS.UPLOAD.TOOLTIP' | translate"
          mat-fab
          color="primary"
          class="fab-t-r"
          (click)="openFileSelector()"
        >
          <mat-icon>upload</mat-icon>
        </button>
      }
    </ng-template>
  </ngx-file-drop>
</mat-card>
